import { render, staticRenderFns } from "./DynamicTestForm.vue?vue&type=template&id=22de365c&scoped=true"
import script from "./DynamicTestForm.vue?vue&type=script&lang=js"
export * from "./DynamicTestForm.vue?vue&type=script&lang=js"
import style0 from "./DynamicTestForm.vue?vue&type=style&index=0&id=22de365c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22de365c",
  null
  
)

export default component.exports